import 'reflect-metadata'

import DateFnsUtils from '@date-io/date-fns'
import React, { useState } from 'react'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Helmet } from 'react-helmet'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { StylesProvider } from '@material-ui/styles'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import { ThemeProvider } from 'styled-components'
import { QueryClient, QueryClientProvider } from 'react-query'

import { MarkerProvider } from 'src/context/Marker'
import maTheme from './theme'
import { Routes } from './routes'
import './App.css'
import { ProfileProvider } from './context/ProfileContext'

export const queryClient = new QueryClient()

const App = () => {
  const [currentTheme] = useState(2)
  return (
    <>
      <Helmet titleTemplate="%s | SKUit" defaultTitle="SKUit - Dashboard" />
      <StylesProvider injectFirst>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <MuiThemeProvider theme={maTheme[currentTheme]}>
            <ThemeProvider theme={maTheme[currentTheme]}>
              <QueryClientProvider client={queryClient}>
                <MarkerProvider>
                  <ProfileProvider>
                    {process.env.NODE_ENV === "development" && <ReactQueryDevtools initialIsOpen={false} />}
                    <Routes />
                  </ProfileProvider>
                </MarkerProvider>
              </QueryClientProvider>
            </ThemeProvider>
          </MuiThemeProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </>
  )
}

export default App
